/*
  "Add gift wrapping" checkbox.

  This element no longer touches the product form. It registers as an add-on
  provider (see assets/cart-addons.js), which batches every add-on on the page
  into a single cart request — so gift wrapping and personalization can both be
  ticked without the two racing each other.
*/
if (!customElements.get('gift-wrapping')) {
  customElements.define(
    'gift-wrapping',
    class GiftWrapping extends HTMLElement {
      connectedCallback() {
        this.checkbox = this.querySelector('.gift-wrapping__checkbox');
        this.flag = this.querySelector('[data-gift-wrapping-flag]');
        this.variantId = this.dataset.variantId;
        this.sectionId = this.dataset.section;
        this.productTitle = this.dataset.productTitle || '';

        if (!this.checkbox) return;

        this.checkbox.addEventListener('change', this.syncFlag.bind(this));
        this.syncFlag();
      }

      // Keeps "Gift wrapping: Yes" off the item unless the box is ticked.
      syncFlag() {
        if (this.flag) this.flag.disabled = !this.checkbox.checked;
      }

      // Called by the coordinator when the shopper submits the product form.
      getAddonItem(form) {
        if (!this.checkbox || !this.checkbox.checked) return null;

        return {
          id: Number(this.variantId),
          quantity: window.CartAddons.quantity(form),
          properties: { For: window.CartAddons.selectionLabel(this.sectionId, this.productTitle) }
        };
      }
    }
  );
}
